













































































    import { Component, Vue, Watch } from 'vue-property-decorator';
    import axios from 'axios';
    import { api } from '@/api';
import { Debounce } from 'lodash-decorators';

    @Component
    export default class Nationalities extends Vue {

        public nationalityName: string = '';
        public nationality: any = {
            id: null,
            en: {
                name: ''
            },
            sr: {
                name: ''
            },
        }

        public nationalities: any[] = [];
        public nationalitiesLoading: boolean = true;

        public dialog: boolean = false;

        public isUpdate: boolean = false;

        public $refs!: {
            form: HTMLFormElement // fix for this.$refs.form.valdiate(); TS error
        }

        public pagination: any = {
            per_page: 10,
            page: 1,
        }
        public totalItems: any = 1;

        get headersLocalized(): any[] {
            return [
                {
                    text: this.$t('table_headers.translated_shared.en.name'),
                    value: 'translations.en.name'
                },
                {
                    text: this.$t('table_headers.translated_shared.sr.name'),
                    value: 'translations.sr.name'
                },
                {
                    text: this.$t('table_headers.shared.actions'),
                    value: 'actions',
                    align: 'end'
                }
            ]
        }

        public close () {
            this.dialog = false;
            this.isUpdate = false;
            this.$refs.form.reset();
        }

        public save () {

            if (this.isUpdate) {
                return this.update();
            }
            
            this.submit();
        }

        public edit(item: any) {
            this.isUpdate = true;
            this.dialog = true;
            this.nationality = { 
                id: item.id,
                en: {
                    name: (item.translations.en) ? item.translations.en.name : '',
                },
                sr: {
                    name: (item.translations.sr) ? item.translations.sr.name : '',
                },
            };
        }

        public loadNationalities() {

            this.nationalitiesLoading = true;

            let payload = {
                page: this.pagination.page,
                per_page: this.pagination.per_page,
            }

            axios.get(api.path('v1.admin.nationalities'), { params: payload })
                .then( res => {
                    this.nationalities = res.data.data;
                    this.totalItems = res.data.meta.total;
                })
                .finally( () => this.nationalitiesLoading = false);
        }

        public getPayload() {
            return {
                id: this.nationality.id,
                en: this.nationality.en,
                sr: this.nationality.sr,
            };
        }

        public submit() {

            let payload = this.getPayload();

            axios.post(api.path('v1.admin.nationalities'), payload )
                .then( res => {
                    this.loadNationalities();
                    this.close();
                });
        }

        public update() {

            let payload = this.getPayload();

            axios.patch(api.path('v1.admin.nationalities.single', { id: payload.id }), payload )
                .then( res => {
                    this.loadNationalities();
                    this.close();
                });
        }

        @Watch('pagination', { deep: true })
        @Debounce(500)
        onFilterValueChange( value: any ) {
            this.loadNationalities();
        }

        public mounted() {
            this.loadNationalities();
        }

    }
